import React, { useState } from "react";
import { updateVin } from "API";

const AddVinModal = ({ open, onClose, vehicle }) => {
    const [vin, setVin] = useState(vehicle?.vin || "");
    const [error, setError] = useState("");
    const handleSubmit = async () => {
        try {
            if (!vehicle?.id) throw new Error("Vehicle not selected");
            console.log("Updating VIN for vehicle", vehicle.id, "to", vin);
            await updateVin(vehicle.id, vin);
            onClose();
        } catch (err) {
            setError(err?.message || "Something went wrong while updating VIN.");
        }
    };

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="w-full max-w-sm rounded-xl bg-white p-6 shadow-lg">
                <h2 className="mb-4 text-lg font-semibold">Update VIN</h2>
                <p>{error}</p>
                <input
                    type="text"
                    placeholder="Enter VIN"
                    onChange={(e) =>
                        setVin(e.target.value.toUpperCase())
                    }
                    className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                />

                <div className="mt-4 flex justify-end gap-2">
                    <button
                        onClick={onClose}
                        className="rounded-md px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={() => {
                            handleSubmit(vin);
                        }}
                        className="rounded-md bg-black px-4 py-2 text-sm font-medium text-white hover:bg-gray-800"
                    >
                        Update VIN
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddVinModal;
